// @ts-expect-error TS(7006): Parameter 'cliente' implicitly has an 'any' type.
const mapClienteFacturaRecurrenteFromApi = (cliente, libradorId = null) => ({
  ...cliente,
  direccion: cliente?.direccion?.calle,
  email: cliente?.email,
  telefono: cliente?.telefonos?.[0]?.contacto,
  cif: cliente?.cif,
  provincia: cliente?.direccion?.provinciaNombre,
  poblacion: cliente?.direccion?.poblacionNombre,
  poblacionId: cliente?.direccion?.poblacionId,
  cp: cliente?.direccion?.codigoPostal,
  poblacionExtranjera: cliente?.direccion?.poblacionExtranjera,
  libradorId,
})

export default mapClienteFacturaRecurrenteFromApi
